import { noop } from 'rxjs';
import { IndentService, NULL_INDENT_SERVICE } from './indentService';

export interface QuoteService extends IndentService {
  readonly isQuoted: boolean;

  quote(): void;
  unquote(): void;
}

export const NULL_QUOTE_SERVICE: QuoteService = {
  ...NULL_INDENT_SERVICE,

  isQuoted: false,

  quote: noop,
  unquote: noop,
};
